import { Component, OnInit, AfterViewInit, ViewEncapsulation, Inject, ChangeDetectorRef } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { GetImageSrcPipe } from 'app/pipes/get-image-src.pipe';
import { filter, map } from 'rxjs/operators';
import { MediaChange, MediaObserver } from '@angular/flex-layout';

@Component({
  selector: 'app-preview',
  templateUrl: './preview.component.html',
  styleUrls: ['./preview.component.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [GetImageSrcPipe]
})
export class PreviewComponent implements OnInit, AfterViewInit {

  modelName: any;
  id: any;
  name: any;
  url: any;
  mqAlias: string;
  mapHeight: any;
  i: any = 0;
  pdf_url: SafeResourceUrl;

  constructor(
    public matDialogRef: MatDialogRef<PreviewComponent>,
    public imgSrc: GetImageSrcPipe,
    public sanitizer: DomSanitizer,
    private mediaObserver: MediaObserver,
    private cdr: ChangeDetectorRef,
    @Inject(MAT_DIALOG_DATA) public _data: any
  ) {
    this.modelName = _data[0];
    this.id = _data[1];
    this.name = _data[2];
    if (this.name.file_name){
      this.name = this.name.file_name;
    }
    if(_data.length > 3){
      this.url = _data[3];
    }
  }

  pdfURL(): string {
    if (this.modelName !== '') {
      const url = this.imgSrc.transform(this.modelName) + this.id + '/' + this.name + '.pdf';
      if (this.i === 0) {
        this.i++;
        return url;
      }
    } else if(this.url !== ''){
      if (this.i === 0) {
        this.i++;
        return this.url;
      }

    } else {
      const url = this.imgSrc.transform('tmp') + this.name + '.pdf';
      if (this.i === 0) {
        this.i++;
        return url;
      }
    }
  }

  ngOnInit(): void {
    this.mediaObserver.asObservable()
      .pipe(
        filter((changes: MediaChange[]) => changes.length > 0),
        map((changes: MediaChange[]) => changes[0])
      )
      .subscribe((change: MediaChange) => {
        this.mqAlias = change.mqAlias;
        let adjustScreen = 265;
        if (this.mqAlias === 'xl' || this.mqAlias === 'gt-lg') {
          adjustScreen = 500;
        }
        this.mapHeight = (window.innerHeight - adjustScreen) + 'px';
      });
  }

  ngAfterViewInit(): void {
    // Ensuring change detection runs after setting the URL
    this.pdf_url = this.pdfURL();
    this.cdr.detectChanges();
  }
}
